        <div class="container">
            <h1>📸 Välkommen till Fototävlingssajten</h1>

            <p class="intro">
                Den moderna lösningen för att arrangera engagerande och professionella
                fototävlingar. Vi har skapat en plattform där uppladdning och röstning är så enkelt
                och översiktligt som möjligt – så att du kan fokusera på det som verkligen betyder
                något: fantastisk fotografering och rättvis bedömning.
            </p>

            <div class="highlight-box">
                <h3>🎯 Varför välja vår fototävlingssajt?</h3>
                <p style="font-size: 1.1em; margin: 10px 0">
                    Vi har designat varje funktion med användarvänlighet i fokus. Resultatet? En
                    smidig upplevelse från första inloggning till slutresultat – för både deltagare
                    och röstare.
                </p>
            </div>

            <h2>✨ Smidigt för deltagare</h2>

            <div class="feature-box">
                <h3>Enkel bilduppladdning</h3>
                <p>
                    Ladda upp dina bilder på bara några sekunder. Dra och släpp din bild eller
                    klicka för att välja – systemet tar hand om resten. Du kan lägga till titlar och
                    beskrivningar som kommer att synas i slutresultatet, perfekt för att dela
                    historien bakom bilden.
                </p>
            </div>

            <div class="feature-box">
                <h3>Automatisk bildhantering</h3>
                <p>
                    Glöm krångliga bildbehandlingsprogram! Vårt system skalar automatiskt ner dina
                    bilder till optimal storlek för visning på alla enheter. Du behöver bara se till
                    att bilden är i JPEG-format och under 15 MB – vi tar hand om resten.
                </p>
            </div>

            <div class="feature-box">
                <h3>Full kontroll över dina bidrag</h3>
                <p>
                    Ångrar du dig? Inget problem! Du kan när som helst redigera titlar,
                    beskrivningar eller ta bort bilder fram till tävlingens deadline. Flexibiliteten
                    ger dig möjlighet att finslipa ditt bidrag tills du är helt nöjd.
                </p>
            </div>

            <h2>🗳️ Intuitiv röstning</h2>

            <div class="feature-box">
                <h3>Dra-och-släpp rangordning</h3>
                <p>
                    Detta är hjärtat av vår plattform! Istället för komplicerade poängsystem eller
                    krångliga formulär kan röstare enkelt dra bilderna till rätt position. Vill du
                    flytta en bild? Ta tag i den och dra dit den hör hemma. Det ger en omedelbar och
                    kristallklar översikt över din rangordning.
                </p>
            </div>

            <div class="feature-box">
                <h3>Jämför bilder sida vid sida</h3>
                <p>
                    Svårt att välja mellan två favoriter? Använd vår jämförelsefunktion för att se
                    bilder bredvid varandra. Zooma in, studera detaljerna och fatta ett välgrundat
                    beslut. Byt plats med ett enkelt knapptryck.
                </p>
            </div>

            <div class="feature-box">
                <h3>Konstruktiv feedback</h3>
                <p>
                    Ge feedback som inspirerar! Röstare kan lämna uppmuntrande kommentarer till
                    bilderna, vilket skapar en positiv och lärorik miljö för alla deltagare.
                </p>
            </div>

            <h2>💡 Fördelar som gör skillnad</h2>

            <div class="benefits">
                <div class="benefit-item">
                    <strong>⚡ Snabbt & Smidigt</strong>
                    <p>
                        Ingen inlärningskurva – systemet är så intuitivt att alla förstår det
                        direkt.
                    </p>
                </div>

                <div class="benefit-item">
                    <strong>📱 Fungerar överallt</strong>
                    <p>
                        Använd din dator, surfplatta eller mobil – upplevelsen är lika bra på alla
                        enheter.
                    </p>
                </div>

                <div class="benefit-item">
                    <strong>🔒 Säker inloggning</strong>
                    <p>
                        Logga in med e-post och lösenord eller använd ditt Facebook-konto för snabb
                        åtkomst.
                    </p>
                </div>

                <div class="benefit-item">
                    <strong>✏️ Flexibel redigering</strong>
                    <p>Ändra din röstning eller dina bidrag så länge tävlingen pågår.</p>
                </div>

                <div class="benefit-item">
                    <strong>👁️ Anonym röstning</strong>
                    <p>
                        Röstningen sker helt anonymt – ingen ser vem som lagt upp vilken bild under
                        röstningen.
                    </p>
                </div>

                <div class="benefit-item">
                    <strong>📄 Professionellt resultat</strong>
                    <p>
                        När tävlingen är över genereras en snygg PDF med alla bilder, kommentarer
                        och resultat.
                    </p>
                </div>
            </div>

            <h2>🎨 Perfekt för alla typer av fototävlingar</h2>

            <p>Oavsett om du arrangerar en:</p>
            <ul>
                <li>
                    <strong>Företagstävling</strong> – Engagera medarbetare med en rolig
                    fotoaktivitet
                </li>
                <li>
                    <strong>Familjetävling</strong> – Samla släkt och vänner i en kreativ utmaning
                </li>
                <li><strong>Föreningstävling</strong> – Skapa gemenskap genom fotografi</li>
                <li><strong>Klubbtävling</strong> – Låt medlemmar visa upp sina bästa bilder</li>
                <li>
                    <strong>Temavecka</strong> – Perfekt för skolor, organisationer eller grupper
                </li>
            </ul>

            <p>
                ...så är vår plattform designad för att göra hela processen enkel, rolig och
                professionell.
            </p>

            <div class="tech-specs">
                <strong>📋 Tekniska specifikationer:</strong>
                <ul style="margin-top: 10px">
                    <li><strong>Bildformat:</strong> JPEG (.jpg eller .jpeg)</li>
                    <li><strong>Max filstorlek:</strong> 15 MB per bild</li>
                    <li>
                        <strong>Automatisk skalning:</strong> Ja, systemet optimerar bilderna
                        automatiskt för optimal visning
                    </li>
                    <li><strong>Enhetskompatibilitet:</strong> Dator, surfplatta och mobil</li>
                </ul>
            </div>

            <div class="cta">
                <h3>Redo att skapa en minnesvärd fototävling?</h3>
                <p style="font-size: 1.1em; margin: 15px 0">
                    Med vår fototävlingssajt får du alla verktyg du behöver för att arrangera en
                    professionell tävling som deltagare och röstare kommer att älska.
                </p>
                <p style="margin-top: 20px">
                    <strong>Enkel uppladdning • Intuitiv röstning • Professionellt resultat</strong>
                </p>
            </div>

            <h2>🚀 Så här kommer du igång</h2>

            <ol style="font-size: 1.05em; line-height: 1.8">
                <li>
                    <strong>Få din inbjudan</strong> – Arrangören skickar en unik länk via e-post
                </li>
                <li>
                    <strong>Registrera dig eller logga in</strong> – Skapa ett konto eller använd
                    Facebook-inloggning
                </li>
                <li>
                    <strong>Ladda upp dina bilder</strong> – Dra och släpp, lägg till titel och
                    beskrivning
                </li>
                <li>
                    <strong>Rösta på andra bilder</strong> – Dra bilderna i din önskade rangordning
                </li>
                <li>
                    <strong>Se resultatet</strong> – När tävlingen är avslutad får du en
                    professionell PDF med alla bilder och resultat
                </li>
            </ol>

            <p
                style="
                    margin-top: 40px;
                    text-align: center;
                    color: #5a8378;
                    font-size: 1.2em;
                    font-style: italic;
                "
            >
                Fototävling har aldrig varit enklare. Välkommen till framtidens sätt att arrangera
                och delta i fototävlingar!
            </p>
        </div>
